// removed by extract-text-webpack-plugin
module.exports = {"page":"-QxZH","title":"_21OR_","heading":"_3vy_C","editListsLink":"_1Ex8g","fakeHeader":"_33AEI","loadingWrapper":"_5zenH"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Home.css
// module id = 855
// module chunks = 0